/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  },
};

(function () {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };

  function orderSizeGroups(order, value) {
    var ordering = {};
    for (var i = 0; i < order.length; i++) ordering[order[i]] = i;

    return value.sort(function (a, b) {
      return ordering[a] - ordering[b] || a.localeCompare(b);
    });
  }

  function getSizeGroup(data) {
    var sizes = data.options_with_values.find((o) => o.name === "size")?.values;
    var sizeGroups = [];
    for (let i = 0; i < sizes.length; i++) {
      var group = sizes[i].title?.split(" | ")[0];
      if (sizeGroups.indexOf(group) === -1) {
        sizeGroups.push(group);
      }
    }
    return sizeGroups;
  }
  function getPreparedData(data, sizeGroups, withPrice) {
    var availableSizeGroups = [];
    var prices = {};
    for (let i = 0; i < data.variants.length; i++) {
      for (let x = 0; x < sizeGroups.length; x++) {
        if (
          data.variants[i].title.includes(sizeGroups[x]) &&
          data.variants[i].inventory_quantity &&
          availableSizeGroups.indexOf(sizeGroups[x]) === -1
        ) {
          availableSizeGroups.push(sizeGroups[x]);
          if (withPrice) {
            prices[sizeGroups[x]] = {
              compare_at_price: Math.round(data.variants[i].compare_at_price),
              price: Math.round(data.variants[i].price),
            };
          }
        }
      }
    }
    availableSizeGroups = orderSizeGroups(sizeGroups, availableSizeGroups);
    return withPrice ? { prices, availableSizeGroups } : availableSizeGroups;
  }

  InstantSearchResult.prototype.isBindEvents = function () {
    var suggestionContainer = this.$instantSearchResult[0];
    suggestionContainer.dataset.track_action = "view_item_list";
    suggestionContainer.dataset.item_list_name = "serp_modal";
    if (this.data) {
      var products = document.querySelectorAll(
        "li.boost-pfs-search-suggestion-item.boost-pfs-search-suggestion-item-product.boost-pfs-ui-item"
      );
      var productsData = this.data.find((x) => x.key === "products");
      console.log("searching", productsData);
      for (let i = 0; i < products.length; i++) {
        var id = products[i].dataset.id;
        var prodData = productsData.values?.find((x) => x.id == id);
        var el = products[i].getElementsByTagName("a")[0];
        var sku = prodData.skus[0];
        var tags = prodData.tags;
        var gender = tags
          .filter((t) => t.substring(0, 2) === "g_")
          ?.map((t) => t.split("g_")[1])
          .join(", ");
        var styleGroup = tags
          .find((t) => t.substring(0, 4) === "stg_")
          ?.split("stg_")[1];
        var styleDescripton = tags
          .find((t) => t.substring(0, 4) === "std_")
          ?.split("std_")[1];
        var colorFamily = tags
          .find((t) => t.substring(0, 3) === "cf_")
          ?.split("cf_")[1];
        var label = tags
          .find((t) => t.substring(0, 4) === "lbl_")
          ?.split("lbl_")[1];
        var category = tags
          .find((t) => t.substring(0, 4) === "cat_")
          ?.split("cat_")[1];
        el.dataset.item_id = sku;
        el.dataset.item_name = prodData.title;
        el.dataset.item_category =
          sku.substring(0, 7) + "_" + prodData.title.split(" - ")[0];
        el.dataset.item_category2 = gender;
        el.dataset.item_category3 = styleGroup + "_" + styleDescripton;
        el.dataset.item_category4 = colorFamily + "_" + sku.substring(10, 13);
        el.dataset.item_category5 =
          prodData.options_with_values[0]?.values[0]?.title.split(" | ")[0] +
          "_" +
          sku.substring(13, 19);
        el.dataset.item_brand = "K-way_" + label;
        el.dataset.item_color_code = sku.substring(10, 13);
        el.dataset.item_size_code = sku.substring(13, 19);
        el.dataset.item_team_code = sku.substring(7, 10);
        el.dataset.item_category_basic = category;
        el.dataset.item_color_family = colorFamily;
        el.dataset.item_size_group =
          prodData.options_with_values[0]?.values[0]?.title.split(" | ")[0];
        el.dataset.item_style_group = styleGroup;
        el.dataset.item_full_price = prodData.compare_at_price_min;
        el.dataset.item_discount_percent = prodData.percent_sale_min;
        el.dataset.discount =
          prodData.compare_at_price_min - prodData.price_min;
        el.dataset.price = prodData.price_min;
        el.dataset.item_position = i + 1;
      }
    }
  };

  // Instant Search Result Item Product Title & Price costumization
  InstantSearchResultItemProduct.prototype.customizeProductTitle = function (
    data
  ) {
    var product_title_split = this.title.split(" - ");
    var product_title = "";
    var product_size_group = "";

    if (product_title_split.length > 1) {
      var product_title_first = product_title_split[0].toUpperCase();
      var product_title_last =
        product_title_split[product_title_split.length - 1].toLowerCase();
      var color =
        product_title_last.charAt(0).toUpperCase() +
        product_title_last.slice(1);
      product_title = product_title_first + "</p> \n" + color;
    } else {
      product_title = this.title;
    }

    var sizeGroups = getSizeGroup(this.data);
    var availableSizeGroups = getPreparedData(this.data, sizeGroups);

    product_size_group =
      "\n<p>" +
      availableSizeGroups
        .map((g) => (g === "No age breakdown" ? "One size" : g))
        .join(" - ");

    product_title = product_title + product_size_group;

    return product_title;
  };

  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice =
    function () {
      // If the multi-currency feature is enabled, update the product price
      this.prepareSuggestionProductPriceData();

      var priceMin = this.data.price_min;
      var compareAtPriceMin = this.data.compare_at_price_min;

      // Check variants
      var hasVariants = this.data.price_max !== priceMin;
      var sizeGroups = getSizeGroup(this.data) || [];
      var preparedData = getPreparedData(this.data, sizeGroups, true) || {};
      var availableSizeGroups = preparedData.availableSizeGroups || [];
      var prices = preparedData.prices || {};

      if (hasVariants && sizeGroups.length > 1) {
        if (availableSizeGroups.length > 0) {
          if (
            availableSizeGroups[0] !== sizeGroups[0] &&
            prices[availableSizeGroups[0]].compare_at_price !==
              compareAtPriceMin
          ) {
            compareAtPriceMin = prices[availableSizeGroups[0]].compare_at_price;
          }
          if (
            availableSizeGroups[0] !== sizeGroups[0] &&
            prices[availableSizeGroups[0]].price !== priceMin
          ) {
            priceMin = prices[availableSizeGroups[0]].price;
          }
        }
      }
      // Check on sale
      var onSale = compareAtPriceMin > priceMin;
      // Format price
      var price = Utils.formatMoney(priceMin);
      var compareAtPrice = "";
      if (this.data && compareAtPriceMin) {
        compareAtPrice = Utils.formatMoney(compareAtPriceMin);
        if (Settings.getSettingValue("search.removePriceDecimal")) {
          price = Utils.removeDecimal(price);
          compareAtPrice = Utils.removeDecimal(compareAtPrice);
        }
      }

      // Build Price
      var result = "";
      if (Settings.getSettingValue("search.showSuggestionProductPrice")) {
        if (
          onSale &&
          Settings.getSettingValue("search.showSuggestionProductSalePrice")
        ) {
          result = this.getTemplate(
            InstantSearchResultItemProduct.tempType.PRICE_SALE
          );
        } else {
          result = this.getTemplate(
            InstantSearchResultItemProduct.tempType.PRICE
          );
        }
      }

      var hrefLangTag = window.location.href.includes("/it") ? "it" : "en";
      if (hasVariants && availableSizeGroups.length > 1) {
        // var firstPriceIndex = result.indexOf('{{regularPrice}}');
        var firstPriceIndex = onSale
          ? result.indexOf("<s>{{compareAtPrice}}")
          : result.indexOf("{{regularPrice}}");
        result =
          result.slice(0, firstPriceIndex) +
          (hrefLangTag === "it" ? " Da " : " From ") +
          result.slice(firstPriceIndex);
      }

      return result
        .replace(/{{regularPrice}}/g, price)
        .replace(/{{compareAtPrice}}/g, compareAtPrice);
    };
  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function () {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile =
      ".site-nav--mobile .search-button, .js-search-destop";
    var searchInputMobile =
      '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = ".drawer__close > button, .drawer_back a";
    jQ(searchButtonMobile)
      .off("click")
      .click(function (e) {
        e.preventDefault();
        //e.stopPropagation();
        jQ(searchInputMobile).focus();
        self.openSuggestionMobile();
        jQ(searchCloseButtonMobile).trigger("click");
      });
  };

  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function () {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = ".site-header__links .search-button";
    var searchInputDesktop = "#SearchContainer #search-input";
    var searchCloseButtonDesktop = ".drawer__close > button";
    jQ(searchButtonDesktop)
      .off("click")
      .click(function (e) {
        e.preventDefault();
        //e.stopPropagation();
        jQ(searchInputDesktop).focus();
        self.openSuggestionStyle3();
        jQ(searchCloseButtonDesktop).trigger("click");
      });
  };

  // Fix search for the Flow theme
  jQ(".site-header__links .search-button").on("click", function () {
    setTimeout(function () {
      boostPFS.initSearchBox();
      if (Utils.isCollectionPage())
        jQ(".search-input-group > .boost-pfs-search-box").val("");
    }, 500);
  });

  /* Fix input doesn't focus in Brooklyn theme */
  InstantSearchStyle3.prototype.afterCloseInstantSearchStyle3 = function (
    isClose
  ) {
    jQ(".mfp-close").trigger("click");
  };
})();
